<template>
   <div class="modal zoom " tabindex="-1" role="dialog" id="modalBloquearHorario"> 
    <div class="modal-dialog modal-md" role="document">
      <div class="modal-content text-left">
        <div class="modal-header">
          <button type="button" class="close" @click="fecharModal" aria-label="Close" ><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title text-left">Bloquear Horário </h4> 
        </div>
        <div class="modal-body"> 
          <div class="form-group">
            <label> Dia: </label>
            {{ oDia }}
          </div>
          <div class="form-group">
            <label> Hora: </label>
            {{ oHora }}
          </div> 
          <div class="form-group">
            <label for="assessores">Quantidade de Assessores</label>
            <input type="number" class="form-control" id="assessores" placeholder="" v-model="assessores" :max="QuantidadeAssessores" min="1">
          </div>
          <div class="form-group">
            <label for="observacoes">Motivo: </label>
            <textarea class="form-control" id="observacoes" rows="3" v-model="observacoes" maxlength="200"></textarea>
            <small><i> {{200 - observacoes.length}} caracteres restantes </i></small>
          </div> 
        </div>
        <div class="modal-footer"> 
          <button type="button" class="btn btn-default" @click="fecharModal" >Fechar</button>
          <button type="button" class="btn btn-primary" @click="bloquear()">Bloquear</button>
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal --> 
</template>

<script>
export default {
  props: ['QuantidadeAssessores', 'dia'],
  created () {
    this.assessores = this.QuantidadeAssessores
    this.unidade = localStorage.getItem('Unidade')
  },
  methods: {
    fecharModal () {
      $('#modalBloquearHorario').modal('hide')
      this.assessores = this.QuantidadeAssessores
      this.observacoes = ''
    },
    bloquear () {
      let agendamentos = {
        agendamento: {},
        CountAssessores: this.assessores,
        tipo: 3,
        coletivo: false,
        data: this.oDia + 'T' + this.oHora,
        observacoes: this.observacoes,
        unidade: this.unidade,
        IdUsuario: JSON.parse(localStorage.getItem('Usuario')).Usuario.Id
      }
      this.$http.post('agendamento/salvar', agendamentos)
      .then(function (res) {
        this.$emit('atualizarAgenda')
        this.fecharModal()
      })
      .catch(function (err) {
        this.loadAdmissao = false
        alert('Ops! - Algo de errado aconteceu.\nEntre em contato com a área de Projetos.')
        console.log(err)
      })
    }
  },
  data () {
    return {
      assessores: this.QuantidadeAssessores,
      observacoes: '',
      unidade: '',
      oDia: '',
      oHora: ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// BloquearHorario.vue?6f64717b